import { URL_ACCOUNT_DETAILS } from '@seek/adv-constants';
import React from 'react';

import DancingDots from 'src/App/Components/DancingDots';
import { useAccountContext } from 'src/modules/ApiClient';
import { getAppVersion, getCountryFromSite } from 'src/utils/config';
import { initialiseLogger } from 'src/utils/logger/logger';
import { triggerRedirect } from 'src/utils/triggerRedirect';

import Dashboard, { type Props } from './Dashboard';

const DashboardWrapper = ({ site, locale, environment }: Props) => {
  const { data: accountContext } = useAccountContext();

  if (!accountContext) {
    return <DancingDots />;
  }

  const hirerAccountId = accountContext.currentAdvertiser.seekId;
  const userId = accountContext.user?.id;
  const country = getCountryFromSite(site);

  const buildVersion = getAppVersion();

  initialiseLogger({
    buildVersion,
    environment,
    hirerAccountId,
    userId,
    country,
  });

  if (accountContext.advertiser?.isAgency) {
    if (triggerRedirect(URL_ACCOUNT_DETAILS)) {
      return <DancingDots />;
    }
  }

  return <Dashboard site={site} locale={locale} environment={environment} />;
};

export default DashboardWrapper;
